<template>
	<div class="scored">
		<vs-row>
			<vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4" class="m-4 p-d">
				        <el-date-picker
							  style="width:100%"
				              v-model="yearmonth"
							  format="yyyy-MM-dd"
							  value-format="yyyy-MM-dd"
				              type="monthrange"
				              range-separator="至"
				              start-placeholder="开始月份"
				              end-placeholder="结束月份">
				        </el-date-picker>
						
			</vs-col>
			<vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
				<el-input v-model="name" placeholder="请输入姓名" class="ml-4"></el-input>
			</vs-col>
			<vs-col vs-type="flex" vs-justify="space-around" vs-align="center" vs-w="5">
				<vs-button color="primary" type="filled" style="width:20%" @click="getlist()">搜索</vs-button>
				<vs-button color="primary" type="filled" style="width:20%" @click="reset()" >重置</vs-button>
				<vs-button color="success" type="filled" style="width:30%" @click="exportall()">批量导出</vs-button>
			</vs-col>
		</vs-row>
		<vs-table ref="table"    :max-items="10"  :data="culturelist">
		  <template slot="thead">
		    <vs-th >序号</vs-th>
		    <vs-th >名称</vs-th>
			<vs-th >姓名</vs-th>
			<vs-th >部门</vs-th>
		    <vs-th >手机号</vs-th>
			<vs-th >创建时间</vs-th>
			<vs-th >提交时间</vs-th>
			<vs-th >自评分</vs-th>
			<vs-th >最终得分</vs-th>
			<vs-th >状态</vs-th>
			<vs-th >操作</vs-th>
		  </template>
		    <template slot-scope="{data}">
		      <tbody v-if="culturelist.length>0">
		        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
		          <vs-td>
		            <p class="product-name font-medium">{{ indextr+1 }}</p>
		          </vs-td>
		          <vs-td>
		            <p class="product-category">{{ tr.name }}</p>
		          </vs-td>
				  <vs-td>
				    <p class="product-category">{{ tr.userName }}</p>
				  </vs-td>
				  <vs-td>
				    <p class="product-category">{{ tr.deptName }}</p>
				  </vs-td>
		          <vs-td>
		            <p class="product-price">{{ tr.phone }}</p>
		          </vs-td>
				  <vs-td>
				    <p class="product-price">{{ tr.assessTime }}</p>
				  </vs-td>
				  <vs-td>
				    <p class="product-price">{{ tr.updateTime?tr.updateTime:'------' }}</p>
				  </vs-td>
				  <vs-td>
				    <p class="product-price">{{ tr.totalScore }}</p>
				  </vs-td>
				  <vs-td>
				    <p class="product-price">{{ tr.finalScore }}</p>
				  </vs-td>
				  <vs-td>
				    <p class="product-price" :class="tr.status==11?'text-danger':tr.status==2?'text-primary':'text-success'" >{{ tr.status==11?"已抽检":tr.status==2?"待考核":"已完成" }}</p>
				  </vs-td>
				  <vs-td>
				    <vs-button class="mr-4" color="primary" type="filled" @click="details(tr,tr.status)"  size="small">详情</vs-button>
					<vs-button class="mr-4" color="success" type="filled" @click="exportexcel(tr.id)"  size="small">导出Excel</vs-button>
					<vs-button color="danger" type="filled" @click="back(tr.id)"  size="small" v-if="tr.status!=11">退回</vs-button>
				  </vs-td>
			      <template class="expand-user" slot="expand">
				    <div class="con-expand-users w-full p-4">
				        <el-descriptions v-for="(item,index) in tr.reviewerTotalScore" :key="index" border :column="1" class="mb-4" labelClassName="expandlabel">
				            <el-descriptions-item label="审核员">{{item.name}}</el-descriptions-item>
				            <el-descriptions-item label="审核时间">{{item.createTime}}</el-descriptions-item>
				            <el-descriptions-item label="总评语">{{item.remarks}}</el-descriptions-item>
				            <el-descriptions-item label="评分">
				              <el-tag size="small">{{item.totalScore}}</el-tag>
				            </el-descriptions-item>
				        </el-descriptions>
				    </div>
				  </template>
		        </vs-tr>
		      </tbody>
		    </template>
		</vs-table>
		<vs-pagination class="mt-4" :total="total" v-model="itemsPerPage"></vs-pagination>
	</div>
</template>
<script>
	export default {
	    data() {
	        return {
				yearmonth:"", //时间段
				name:"",
				culturelist: [],
				total:0,
				itemsPerPage:1,
				id:'',
			}
	    },
		mounted() {
			this.getlist();
		},
		watch: {
		    itemsPerPage:'getlist'
		}, 
		methods:{
			reset(){
				this.yearmonth=[];
				this.name='';
				this.getlist();
			},
			back(id){
				console.log("退回id",id);
				var that=this;
				this.$confirm('此操作将退回该记录，须重新进行考核测评, 是否继续?', '提示', {
				          confirmButtonText: '确定',
				          cancelButtonText: '取消',
				          type: 'warning'
				        }).then(() => {
							that.$api.backstafflist({id:id}).then(function (response) {
								if(response.code==0){
									 that.$vs.notify({
									 	  title:"提示",
									 	  color:'success',
									 	  text:response.message,
									 	  position:'top-center'
									 });
									 that.getlist();
								}else{
									that.$vs.notify({
										  title:"提示",
										  color:'warning',
										  text:response.message,
										  position:'top-center'
									});
								}
							  }) 
				        }).catch(() => {
				          this.$message({
				            type: 'info',
				            message: '已取消'
				          });          
				        });
			},
			getlist(){    //获取列表
					 const thisIns = this;
					 var start=thisIns.yearmonth[0]||'';
					 var end=thisIns.yearmonth[1]||'';
					 this.$api.finishstaffassess({pageNum:thisIns.itemsPerPage,pageSize:10,status:"10,11",startTime:start,endTime:end,name:thisIns.name}).then(function (response) {
					 	console.log("列表数据：",response);
					 	if(response.code==0){
					 		 thisIns.culturelist=response.data.data;
					 		 thisIns.total=response.data.pages;
					 	}else{
					 		thisIns.$vs.notify({
					 			  title:"提示",
					 			  color:'warning',
					 			  text:response.message,
					 			  position:'top-center'
					 		});
					 	}
					   }) 
			},
			details(item,status){  //详情
				localStorage.setItem("userdetails",JSON.stringify(item));
				this.$router.push({path:'/admin/notesdetails',query:{id:item.id,status:status}})
			},
			exportexcel(id){
				let token = localStorage.getItem('token');
				window.open(`${this.$baseURL}/staffAssess/conserve?id=${id}&authorization=${token}`);
			},
			exportall(){
				console.log("批量导出");
				var start=this.yearmonth[0]||'';
				var end=this.yearmonth[1]||'';
				let token = localStorage.getItem('token');
				window.open(`${this.$baseURL}/staffAssess/queryCompleteStaffAssessExport?pageNum=${this.itemsPerPage}&pageSize=10&status=10&startTime=${this.start||""}&endTime=${this.end||""}&name=${this.name}&authorization=${token}`);
			},
			
		},
	}
</script>
<style type="text/css">
	.expandlabel{
		width: 200px;
	}
</style>
